export const ChevronDownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width={props.width ?? 24}
      height={props.height ?? 24}
      viewBox={props.viewBox ?? "0 0 24 24"}
      fill={props.fill ?? "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10L12 16L18 10"
        stroke={props.stroke ?? "#1C1C1C"}
        strokeWidth={props.strokeWidth ?? "2"}
        strokeLinecap={props.strokeLinecap ?? "round"}
        strokeLinejoin={props.strokeLinejoin ?? "round"}
      />
    </svg>
  );
};
